import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

function AlertPopup({ onOpen, onConfirm, message, toggle, title, description }) {
  const [checkBoxState, setCheckBoxState] = useState(false);

  return (
    <Modal show={onOpen} backdrop="static" className="common-custom-modal modal-small" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{title}</span>
          </Modal.Title>
          <span onClick={toggle} className="icon-close cursor-pointer text-dark text-decoration-none" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          <span>
            <p className="mb-2 font-14">{message}</p>{' '}
            <span>
              {' '}
              <div className="common-checkbox">
                <input type="checkbox" id="delConfirm" name="delConfirm" onChange={(e) => setCheckBoxState(e.target.checked)} value="delete" />
                <label htmlFor="delConfirm" className="chklabel">
                  <span className="font-14">{description}</span>
                </label>
              </div>
            </span>
          </span>
          <div className="common-model-footer mt-4">
            <button onClick={onConfirm} disabled={!checkBoxState} className="btn p-0">
              <span className="icon-Tick-1 f-24" />
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
}

export default AlertPopup;
